export default {"src":"/_next/static/media/share.dfad9a8c.svg","height":19,"width":16,"blurWidth":0,"blurHeight":0};